"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponReceive = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var coupon_1 = require("../../model/coupon");
var service_1 = require("../../../library/base/service");
var CouponReceive = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CouponReceive, _super);
    function CouponReceive() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取优惠券';
        _this.code = '300204';
        _this.desc = '获取优惠券';
        _this.requestParams = new coupon_1.CouponReceiveRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CouponReceive;
}(service_1.BaseService));
exports.CouponReceive = CouponReceive;
//# sourceMappingURL=couponReceive.js.map